import { render } from "./FavoriteButton.vue?vue&type=template&id=bea46a30&scoped=true"
import script from "./FavoriteButton.vue?vue&type=script&lang=js"
export * from "./FavoriteButton.vue?vue&type=script&lang=js"

import "./FavoriteButton.vue?vue&type=style&index=0&id=bea46a30&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bea46a30"]])

export default __exports__